import PublicLayout from "@/components/PublicLayout";
import { Card } from "@/components/ui/card";
import { Users, Truck, MapPin, Calendar } from "lucide-react";

export default function AboutPage() {
  return (
    <PublicLayout>
      <section className="bg-gradient-to-br from-[#0F172A] to-[#1E3A8A] text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold">About Maa Vindhyavasini Packers Movers & Transport</h1>
          <p className="mt-3 text-slate-200 max-w-2xl">Ek family-run business — Noida se shuru hui, aaj poore Delhi NCR ka bharosemand naam.</p>
        </div>
      </section>

      <section className="py-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0F172A]">Hamari Kahani</h2>
          <p className="mt-4 text-slate-700 leading-relaxed">
            2010 mein Noida ke ek chhote godown se shuru hue Maa Vindhyavasini Packers Movers & Transport ne apna business trust aur service quality ke dam par khada kiya. Aaj hamari team mein 45+ trained members hain, 25+ own trucks hain, aur poore Delhi NCR mein hum har din 15-20 families ka shifting handle karte hain.
          </p>
          <p className="mt-3 text-slate-700 leading-relaxed">
            Hamari philosophy simple hai: <strong>"Aapka saman aapka bharosa hai. Hum use apna samajhkar handle karte hain."</strong>
          </p>
          <p className="mt-3 text-slate-700 leading-relaxed">
            GSTIN registered, IBA approved, ₹5 lakh transit insurance included — hum har wo cheez follow karte hain jo ek professional mover ko karni chahiye.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[
            { icon: Calendar, num: "15+", label: "Years in NCR" },
            { icon: Users, num: "50K+", label: "Happy Families" },
            { icon: Truck, num: "25+", label: "Own Fleet Trucks" },
            { icon: MapPin, num: "6 Cities", label: "Delhi NCR Coverage" },
          ].map((s) => (
            <Card key={s.label} className="p-6 text-center border-2 border-orange-100">
              <s.icon className="w-8 h-8 mx-auto text-[#F97316]" />
              <div className="font-display text-3xl font-extrabold text-[#0F172A] mt-2">{s.num}</div>
              <div className="text-sm text-slate-500">{s.label}</div>
            </Card>
          ))}
        </div>
      </section>

      <section className="py-14 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0F172A] text-center">Hamare Values</h2>
          <div className="grid md:grid-cols-3 gap-6 mt-8">
            {[
              { title: "Honest Pricing", desc: "Quote diya to quote diya. Loading ke waqt price nahi badalti. Written quotation guaranteed." },
              { title: "Care Like Own", desc: "Har box, har furniture piece aap ka hai — hum use apna samajhkar handle karte hain." },
              { title: "On-Time Always", desc: "Committed time pe pahunchna, committed time pe deliver karna — ye hamara vada hai." },
            ].map((v) => (
              <Card key={v.title} className="p-6 border border-slate-200">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#F97316] to-[#EAB308] mb-3" />
                <h3 className="font-display font-bold text-xl text-[#0F172A]">{v.title}</h3>
                <p className="text-sm text-slate-600 mt-2">{v.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
